import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { AuthService } from '../services/auth.service';
import { LocalStorageService } from '../../core/storage/local-storage.service';
import { LockScreenService } from '../../core/services/lock-screen.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private localStorageService: LocalStorageService,
        private lockScreenService: LockScreenService
    ) {}

    canActivate(): boolean {
        const isAuthenticated = this.auth.isAuthenticated();
        const tokenExpiration = this.auth.getTokenExpirationDateTime();

        if (isAuthenticated) {
            if (tokenExpiration > DateTime.now()) {
                return true;
            } else {
                this.router.navigateByUrl('/auth/login');
            }
        }

        this.router.navigateByUrl('/auth/login');
        this.localStorageService.clear();
        this.lockScreenService.unLock(); // Token expired olduğunda lock screen'i de temizle
        return false;
    }
}
